import React, { useEffect } from "react";

// components
import { Card, CardBody, Row, Col, Spinner, Form, Modal, ModalHeader, ModalBody } from "reactstrap";
import MaterialTable from 'material-table';

// style
import "../../assets/css/loading.css";
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// helpers
import { showMessage } from "../../helpers/message.js";

// api
import setup_api from "../../api/setup_api.js";
import dashboard_api from "../../api/dashboard_api.js";
import VistoriaLista from "../Shared/VistoriaLista";
import contrato_api from "../../api/contrato_api";

export default function Dashboard() {

  const [showLoading, setshowLoading] = React.useState(false);

  const [dashboard, set_dashboard] = React.useState(null);
  const [setup, set_setup] = React.useState(null);
  const [situacaoAnalise, set_situacaoAnalise] = React.useState(null);
  const [listFormulariosExecucoes, set_listFormulariosExecucoes] = React.useState([]);

  // state de controle de visibilidade do modal
  const [visible_modal, set_visible_modal] = React.useState(false);

  const toggleModal = () => set_visible_modal(!visible_modal);

  const loadDashboard = () => {
    setup_api.get().then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_setup(result.data);
      }
    });
    setshowLoading(true);
    dashboard_api.get().then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_dashboard(result.data);
      }
    })
  }

  useEffect(() => {
    loadDashboard();
  }, []);

  const handleCardSituacaoAnaliseBoletim = (item) => {
    return (
      <Card Style="cursor:pointer" onClick={() => set_situacaoAnalise(item.situacaoAnalise)}>
        <CardBody>
          <Row>
            <Col md="2">
              <i className={item.icon + " fa-2x text-secondary"}></i>
            </Col>
            <Col md="10" className="text-right">
              <h6 Style="margin-bottom: 0 !important" className="text-secondary">{item.situacaoAnaliseResumida}</h6>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md="10">
              <label>{item.descricao}</label>
            </Col>
            <Col md="2" className="text-right">
              <h6 Style="margin-bottom: 0 !important" className="text-secondary">{item.quantidade}</h6>
            </Col>
          </Row>
        </CardBody>
      </Card>
    )
  }

  const handleReturnList = (reload) => {
    set_situacaoAnalise(null);
    if (reload)
      loadDashboard();
  }

  //Função de visualizar da tabela de execuções
  const visualizar = (rowData) => {
    setshowLoading(true);
    contrato_api.GetListFormulariosDashboard(rowData.contrato_Id).then(response => {
      setshowLoading(false);
      if (response.status !== 200) {
        showMessage("Aviso", response.message, 'error', null);
      }
      else {
        set_listFormulariosExecucoes(response.data);
        toggleModal();
      }
    })
  }

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className={situacaoAnalise ? "d-none" : "content"}>
        <Row className="pt-4">
          {setup && setup.urlAndroid &&
            <Col md="4" lg="2">
              <Card className="" Style="cursor:pointer" color="success" onClick={() => window.open(setup.urlAndroid, "_blank")}>
                <CardBody>
                  <Row>
                    <Col md="3" className="text-center">
                      <i className="fab fa-android fa-3x text-white"></i>
                    </Col>
                    <Col md="9" className="text-center">
                      <label className="text-white">Baixar o Aplicativo</label>
                      <strong className="text-white"> Android</strong>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          }
          {setup && setup.urlIOS &&
            <Col md="4" lg="2">
              <Card Style="cursor:pointer" color="secondary" onClick={() => window.open(setup.urlIOS, "_blank")}>
                <CardBody>
                  <Row>
                    <Col md="3" className="text-center">
                      <i class="fab fa-apple fa-3x text-white"></i>
                    </Col>
                    <Col md="9" className="text-center">
                      <label className="text-white">Baixar o Aplicativo</label>
                      <strong className="text-white">IOS</strong>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          }
        </Row>
        <h4 className="titleCard">Análise dos Boletins de Vistoria</h4>
        <Row>
          {dashboard && dashboard.indicadoresAnaliseBoletimVistoria.map((m, key) => {
            return <Col md="6" lg="4" key={key}>{handleCardSituacaoAnaliseBoletim(m)}</Col>
          })}
        </Row>
        <h4 className="titleCard">Pedido de Vista</h4>
        <Row>
          {dashboard && dashboard.indicadorPedidoVista &&
            <Col md="6" lg="4">{handleCardSituacaoAnaliseBoletim(dashboard.indicadorPedidoVista)}</Col>
          }
        </Row>
        {
          dashboard && dashboard.execucoesDeFiscalizacoes && dashboard.execucoesDeFiscalizacoes.length > 0 &&
          <>
            <Form>
              <MaterialTable style={{ minHeight: "auto" }}
                title="Execução de Fiscalizações"
                columns={[
                  { title: "Concessionária", field: 'concessionaria' },
                  { title: "Identificação do contrato", field: 'identificacaoContrato' },
                  { title: "Número do processo", field: 'numeroProcesso' },
                  { title: "Mínimo de vistorias", field: 'minimoVistorias' },
                  { title: "Vistorias realizadas", field: 'vistoriasRealizadas' }
                ]}
                data={dashboard.execucoesDeFiscalizacoes}
                isLoading={false}
                options={{
                  ...table_style,
                  filtering: false,
                  exportButton: true
                }}
                actions={[
                  {
                    icon: 'search',
                    tooltip: 'Visualizar Registro',
                    onClick: (event, rowData) => visualizar(rowData)
                  }
                ]}
                localization={table_translate}
              />
            </Form>
            <Modal isOpen={visible_modal} toggle={toggleModal} size="xl">
              <ModalHeader toggle={toggleModal}>Execuções</ModalHeader>
              <ModalBody>
                <MaterialTable style={{ minHeight: "auto" }}
                  title=""
                  columns={[
                    { title: "Formulário", field: 'formulario' },
                    { title: "Quantidade de vistorias", field: 'quantidadeDeVistorias' },
                  ]}
                  data={listFormulariosExecucoes}
                  isLoading={false}
                  options={{
                    ...table_style,
                    filtering: false,
                    exportButton: true
                  }}
                  actions={[]}
                  localization={table_translate}
                />
              </ModalBody>
            </Modal>
          </>
        }
      </div>
      {situacaoAnalise &&
        <VistoriaLista
          situacaoAnalise={situacaoAnalise}
          setshowLoading={setshowLoading}
          handleReturn={handleReturnList}
        />
      }
    </>
  );
}

